import { apiGet, apiPost, apiUpdate } from "../http";
export default {
  async exportProductsAPI(data) {
    return await apiPost("api/export", data);
  },
  async exportHistoryAPI() {
    return await apiGet("api/export/history");
  },
  async searchProductAPI(data) {
    return await apiPost("api/products/search", data);
  },
  async aiAutofill(context, formData) {
    return await apiPost('api/products/ai-autofill', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  async aiAutofillProducts(context, formData) {
    return await apiPost('api/products/ai-autofill-products', formData);
  },
  async addProductAPI(data) {
    return await apiPost("api/products", data);
  },
  async getProductLocationAPI(data) {
    return await apiGet("api/products/locations/" + data);
  },
  async search_SKU_API(data) {
    return await apiPost("api/products/sku", data);
  },
  async updatePrices(data) {
    return await apiPost("api/products/updatePrices", data);

  },
  async getDataSKU_API(data) {
    return await apiPost("api/products/writeDescription", data);
  },
  async putProductAPI(data) {
    return await apiUpdate("api/products", data);
  },
  async postNewVariationAPI(data) {
    return await apiPost("api/products/variations", data);
  },
  async postVariationAPI(data) {
    return await apiPost("api/products/variations", data);
  },
  async filterProductsAPI(data, isPiguLt, page = 1, limit = 100) {
    var basePath = "api/products/filter";
    var queryParams = [];

    if (isPiguLt) {
      queryParams.push("exportPiguLT=true");
    }

    queryParams.push(`page=${page}`);
    queryParams.push(`limit=${limit}`);

    var path = basePath + "?" + queryParams.join("&");

    return await apiPost(path, data);
  },
  async getNotExportedAPI() {
    return await apiGet("api/products/notExported");
  },
  async getExportedAPI() {
    return await apiGet("api/products/Exported");
  },
  async getRequiresAttentionAPI() {
    return await apiGet("api/products/requiresAttention");
  },
  async putResolvedProductAPI(data) {
    return await apiUpdate("api/products/resolve", data);
  },
  async deletePhotoAPI(data) {
    return await apiPost("api/products/deletePhoto", data);
  },
  async getProductPhotosAPI(data) {
    return await apiGet("api/products/orderPhotos/" + data);
  },
  async postPhotosAPI(data) {
    return await apiPost("api/products/photos", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  async putOrderedPhotosAPI(data) {
    return await apiUpdate("api/products/orderPhotos/" + data.SKU, data.photos);
  },
  async undoUpdateQuantityAPI(data) {
    return await apiPost("api/products/undoUpdateQuantity", data);
  },
  async updateQuantityAPI(data) {
    return await apiPost("api/products/updateQuantity", data);
  },
  async getProductsForPlatformUploadAPI(data) {
    return await apiPost(`api/platformUpload/forUpload`, data);
  },
  async getProductsToTranslateAPI(data) {
    return await apiPost(`api/platformUpload/missingTranslations`, data);
  },
  async getDefectDescriptionsAPI(category) {
    return await apiGet(`api/products/defectDescriptions/${category}`);
  },
  async changeStateToNotExportedAPI(data) {
    return await apiPost(`api/products/stateToNotExported`, data);
  },
  async changeLocationAPI(data) {
    return await apiPost("api/products/changeLocation", data);
  },
  async getProductsBySkusAPI(data) {
    return await apiPost("api/products/findSkus", data);
  },
};
